var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, TextField, Typography, } from "@mui/material";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { MONITORING_EXPORT } from "@/queries/MonitoringExport";
import { EMonitoringExportFormat, } from "./types";
import { EExportRange, exportBound, exportRange } from "./lib/exportRange";
import { EMonitoringErrorCode, monitoringErrorCode } from "./lib/errors";
import { exportFailure } from "./lib/exportErrors";
import { TimeZonePicker } from "@/components/timezones/TimeZonePicker";
import { formatWallTime, useTimeZoneService } from "@/components/timezones/timeZoneService";
/**
 * Export monitoring data as CSV or SQL over a range. As with the electoral log
 * export, the file is made by a task that the task widget follows and downloads.
 */
export function MonitoringExportDialog(_a) {
    var _this = this;
    var _b;
    var open = _a.open, onClose = _a.onClose, title = _a.title, scope = _a.scope, timeZone = _a.timeZone, target = _a.target, _c = _a.initialFormat, initialFormat = _c === void 0 ? EMonitoringExportFormat.CSV : _c, onSnapshotPruned = _a.onSnapshotPruned, _d = _a.widgets, widgets = _d === void 0 ? [] : _d;
    var t = useTranslation().t;
    var service = useTimeZoneService();
    var _e = useState(timeZone), chosenZone = _e[0], setChosenZone = _e[1];
    var _f = useState(initialFormat), format = _f[0], setFormat = _f[1];
    var _g = useState(""), from = _g[0], setFrom = _g[1];
    var _h = useState(""), to = _h[0], setTo = _h[1];
    var _j = useState(false), sending = _j[0], setSending = _j[1];
    var _k = useState(), failure = _k[0], setFailure = _k[1];
    var exportData = useMutation(MONITORING_EXPORT)[0];
    var _l = useWidgetStore(), addWidget = _l[0], setWidgetTaskId = _l[1];
    useEffect(function () {
        if (!open)
            return;
        setFormat(initialFormat);
        setFailure(undefined);
        setChosenZone(timeZone);
    }, [open, initialFormat, timeZone]);
    var range = exportRange(from, to, chosenZone);
    var boundNote = function (value) {
        if (!value)
            return undefined;
        try {
            if (service.zonedToInstant(value.slice(0, 16), chosenZone).kind === "gap") {
                return t("lifecycle.import.error.dstGap", {
                    dateTime: formatWallTime(value, service.text),
                    city: service.zoneCity(chosenZone, service.text),
                });
            }
            return service.zonedTimeNote(value.slice(0, 16), chosenZone, service.text);
        }
        catch (_a) {
            return t("lifecycle.import.error.invalidDateTime");
        }
    };
    /** The dialog stays open until the export is started, so a refusal can be told. */
    var start = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, taskId, widget, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (range !== EExportRange.VALID)
                        return [2 /*return*/];
                    setSending(true);
                    setFailure(undefined);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, exportData({
                            variables: __assign(__assign({}, target), { format: format, from: exportBound(from, chosenZone), to: exportBound(to, chosenZone) }),
                        })];
                case 2:
                    data = (_b.sent()).data;
                    taskId = (_a = data === null || data === void 0 ? void 0 : data.monitoringExport.task_execution) === null || _a === void 0 ? void 0 : _a.id;
                    if (!taskId) {
                        setFailure(t("monitoring.errors.unknown"));
                        return [2 /*return*/];
                    }
                    widget = addWidget(ETasksExecution.EXPORT_MONITORING_DATA, true);
                    setWidgetTaskId(widget.identifier, taskId);
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    if (monitoringErrorCode(error_1) === EMonitoringErrorCode.SNAPSHOT_PRUNED) {
                        onSnapshotPruned === null || onSnapshotPruned === void 0 ? void 0 : onSnapshotPruned();
                    }
                    setFailure(exportFailure(error_1, t, widgets));
                    return [3 /*break*/, 5];
                case 4:
                    setSending(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Dialog, { variant: "info", open: open, title: t("monitoring.export.title"), ok: t("monitoring.export.export"), cancel: t("monitoring.export.cancel"), okEnabled: function () { return range === EExportRange.VALID && !sending; }, errorMessage: failure, handleClose: function (confirmed) {
            if (confirmed)
                void start();
            else
                onClose();
        }, children: _jsxs(Stack, { spacing: 2, sx: { pt: 1 }, children: [_jsxs(Typography, { variant: "body2", children: [title, " \u00B7 ", scope] }), _jsxs(FormControl, { children: [_jsx(FormLabel, { id: "monitoring-export-format", children: t("monitoring.export.format") }), _jsxs(RadioGroup, { row: true, "aria-labelledby": "monitoring-export-format", value: format, onChange: function (event) {
                                return setFormat(event.target.value);
                            }, children: [_jsx(FormControlLabel, { value: EMonitoringExportFormat.CSV, control: _jsx(Radio, {}), label: t("monitoring.export.csv") }), _jsx(FormControlLabel, { value: EMonitoringExportFormat.SQL, control: _jsx(Radio, {}), label: t("monitoring.export.sql") })] })] }), _jsxs(Stack, { direction: { xs: "column", sm: "row" }, spacing: 2, children: [_jsx(TextField, { id: "monitoring-export-from", type: "datetime-local", label: t("monitoring.export.from"), value: from, onChange: function (event) { return setFrom(event.target.value); }, slotProps: { inputLabel: { shrink: true } }, error: !!from && exportRange(from, "", chosenZone) !== EExportRange.VALID, helperText: boundNote(from), fullWidth: true }), _jsx(TextField, { id: "monitoring-export-to", type: "datetime-local", label: t("monitoring.export.to"), value: to, onChange: function (event) { return setTo(event.target.value); }, slotProps: { inputLabel: { shrink: true } }, error: range !== EExportRange.VALID, helperText: (_b = boundNote(to)) !== null && _b !== void 0 ? _b : (range === EExportRange.END_NOT_AFTER_START
                                ? t("monitoring.export.invalidRange")
                                : undefined), fullWidth: true })] }), _jsx(TimeZonePicker, { label: t("lifecycle.input.timezone"), value: chosenZone, onChange: function (zone) {
                        if (zone)
                            setChosenZone(zone);
                    } }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: t("monitoring.export.timeZoneHelp", {
                        timeZone: service.zoneLabel(timeZone, service.text),
                    }) })] }) }));
}
